import { t } from 'i18next';
import GolfIcon from '../GolfIcon';

interface PenaltyInputProps {
  label: string;
  value: number;
  onIncrease: () => void;
  onDecrease: () => void;
  colorClass?: string;
}

export const PenaltyInput = ({
  label,
  value,
  onIncrease,
  onDecrease,
  colorClass = 'text-primary'
}: PenaltyInputProps) => {
  return (
    <div className="flex-1 rounded-lg p-2">
      <div className="flex flex-col items-center">
        <div className="flex items-center">
          <button
            onClick={onDecrease}
            className="size-7 border-2 border-solid flex items-center justify-center border-secondary rounded-full"
            disabled={value === 0}
          >
            <GolfIcon name="minus" className="size-4" />
          </button>
          <div className={`w-8 text-center font-bold ${colorClass}`}>{value}</div>
          <button
            onClick={onIncrease}
            className="size-7 border-2 border-solid flex items-center justify-center border-secondary rounded-full"
            disabled={value >= 9}
          >
            <GolfIcon name="plus" className="size-4" />
          </button>
        </div>
        <div className="text-xs text-muted-foreground mb-1">{t(label)}</div>
      </div>
    </div>
  );
};